export const usersTypes = {
  SIGN_IN: 'SIGN_IN',
  SAVE_TOKEN: 'SAVE_TOKEN',
  SAVE_APP_ID: 'SAVE_APP_ID',
  SWITCH_WORKSPACE: 'SWITCH_WORKSPACE',
  SET_IS_SIGNING_OUT: 'SET_IS_SIGNING_OUT'
};

export const viewsTypes = {
  SET_VIEW: 'SET_VIEW',
  TOGGLE_TIMEPAD: 'TOGGLE_TIMEPAD'
};

export const snippetTypes = {
  SET_SNIPPETS: 'SET_SNIPPETS'
};

export const preferenceTypes = {
  SET_PREFERENCES: 'SET_PREFERENCES',
  UPDATE_PREFERENCES: 'UPDATE_PREFERENCES'
};

export const actionsTypes = {
  SET_ACTIVE_CARD: 'SET_ACTIVE_CARD'
};

export const ticketsTypes = {
  GET_TICKETS: 'GET_TICKETS',
  REFETCH_TICKETS: 'REFETCH_TICKETS',
  FETCH_STATUSES: 'FETCH_STATUSES',
  SAVE_TIME_ENTRY: 'SAVE_TIME_ENTRY',
  SET_THREAD_META: 'SET_THREAD_META',
  UPDATE_THREAD_META: 'UPDATE_THREAD_META',
  SET_TICKETS_WITH_DRAFT: 'SET_TICKETS_WITH_DRAFT',
  SET_THREADS_WITH_ACTIVE_TIMER: 'SET_THREADS_WITH_ACTIVE_TIMER',
  SET_LIVE_THREADS: 'SET_LIVE_THREADS'
};

export const modalTypes = {
  UPDATE_MODAL: 'UPDATE_MODAL'
};

export const actionStatuses = {
  FULFILLED: '_FULFILLED',
  PENDING: '_PENDING',
  REJECTED: '_REJECTED'
};

export const copilotTypes = {
  TOGGLE_ONBOARDING_STATE: 'TOGGLE_ONBOARDING_STATE'
};

export const chatTypes = {
  SET_MAIN_CHAT_FILTERS: 'SET_MAIN_CHAT_FILTERS'
};
